import { Paper } from '@trackman/web-shared-components';
import React from 'react';
import styled from 'styled-components';
import { black, darkgrey } from 'styles/Colors';

export const DragIndicator = styled.div`
  position: absolute;
  width: 100%;
  height: 6px;
  top: calc(50% - 3px);
  background-color: ${black};
`;

export const CardWrapper = styled.div``;

export const LineupListWrapper = styled.div`
  height: calc(100% - 43px);
  position: relative;

  .player-selector .autosuggest-wrapper .react-autosuggest__suggestions-container--open {
    left: -50px;
  }
`;
